module.exports = __webpack_public_path__ + "img/icon-level-2.cf09853d.png";